<template>
  <div>
    <div
      id="addClaimItemModal"
      class="modal fade"
      role="dialog"
      aria-labelledby="modelSingle"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg" role="document">
        <!--begin::Form-->
        <form class="kt-form" ref="formItem" @submit="formSubmit">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="kt-portlet__body">
                <div class="kt-section kt-section--first">
                  <div v-show="this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'">
                    <h3 class="kt-section__title">
                      รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ:
                    </h3>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required">ชนิดเครื่อง:</label>
                          <select2
                            id="bciMachineTypeCode"
                            name="bciMachineTypeCode"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="bciMachineTypeCodeOptions"
                            v-model="bciMachineTypeCode"
                            ref="bciMachineTypeCodeSelect2"
                            @selectChange="onMachineTypeCodeChange"
                          ></select2>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required"
                            >BARCODE (เครื่องเบียร์สด):</label
                          >
                          <input
                            id="bciMachineBarcode"
                            name="bciMachineBarcode"
                            v-model="bciMachineBarcode"
                            type="text"
                            maxlength="50"
                            class="form-control"
                            placeholder="BARCODE (เครื่องเบียร์สด)"
                            @blur="onBlurBarcode(true)"
                            :disabled="IsDisabledMachineBarcode"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>ประเภทเครื่องเบียร์สด:</label>
                          <!-- <label class="label-required">ประเภทเครื่องเบียร์สด:</label> -->
                          <select2
                            id="bciMachineCategory"
                            name="bciMachineCategory"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="bciMachineCategoryOptions"
                            v-model="bciMachineCategory"
                            ref="bciMachineCategorySelect2"
                            :disabled="IsDisabled"
                          ></select2>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label"
                            >ปริมาณแรงดัน Co2 (PSI./BAR):</label
                          >
                          <input
                            id="bciPressure"
                            name="bciPressure"
                            v-model="bciPressure"
                            type="number"
                            min="0"
                            class="form-control"
                            placeholder="ปริมาณแรงดัน Co2"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>อุณหภูมิน้ำในเครื่อง (องศาเซลเซียส):</label>
                          <input
                            id="bciTemperature"
                            name="bciTemperature"
                            v-model="bciTemperature"
                            type="number"
                            min="0"
                            class="form-control"
                            placeholder="อุณหภูมิน้ำในเครื่อง"
                          />
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>วันล้างเครื่องล่าสุด:</label>
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="bciPMDate"
                              name="bciPMDate"
                              ref="bciPMDate"
                              :disabled="IsDisabledDate"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                            <span class="form-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>วันที่จัมพ์ถัง:</label>
                          <div class="input-group date">
                            <input
                              readonly
                              :disabled="isEdit"
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="bciJumpDate"
                              name="bciJumpDate"
                              ref="bciJumpDate"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                            <span class="form-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-show="this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'">
                    <h3 class="kt-section__title">
                      รายละเอียด การใช้งาน และการบำรุงรักษา:
                    </h3>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required">มาตรฐานติดตั้ง:</label>
                          <select2
                            id="bciStandardInstallCode"
                            name="bciStandardInstallCode"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="bciStandardInstallCodeOptions"
                            v-model="bciStandardInstallCode"
                            ref="bciStandardInstallCodeSelect2"
                            @selectChange="onStandardInstallCodeChange"
                          ></select2>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 class="kt-section__title">
                      รายละเอียด สินค้าเบียร์สด:
                    </h3>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>แบรนด์สินค้า:</label>
                          <!-- <label class="label-required">แบรนด์สินค้า:</label> -->
                          <input
                            id="bciProductBrand"
                            name="bciProductBrand"
                            v-model="bciProductBrand"
                            type="text"
                            maxlength="450"
                            class="form-control"
                            placeholder="แบรนด์สินค้า"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required">ชื่อสินค้า:</label>
                          <select2
                            id="bciMaterialCode"
                            name="bciMaterialCode"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="bciMaterialCodeOptions"
                            v-model="bciMaterialCode"
                            ref="bciMaterialCodeSelect2"
                            @selectChange="onMaterialCodeChange"
                          ></select2>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required"
                            >BARCODE (ถัง):</label
                          >
                          <input
                            id="bciBarcode"
                            name="bciBarcode"
                            v-model="bciBarcode"
                            type="text"
                            maxlength="50"
                            class="form-control"
                            placeholder="BARCODE (ถัง)"
                            @blur="onBlurBarcode(false)"
                            :disabled="IsDisabledBarcode"
                          />
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>วันผลิตข้างถัง:</label>
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="bciManufacturingDate"
                              name="bciManufacturingDate"
                              ref="bciManufacturingDate"
                              :disabled="IsDisabledDate"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                            <span class="form-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>น้ำหนักรวมถัง (กิโลกรัม):</label>
                          <input
                            id="bciWeight"
                            name="bciWeight"
                            v-model="bciWeight"
                            type="number"
                            min="0"
                            class="form-control"
                            placeholder="น้ำหนักรวมถัง"
                          />
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required">เลขที่ Invoice :</label>
                          <input
                            id="bciInvoice"
                            name="bciInvoice"
                            v-model="bciInvoice"
                            type="text"
                            maxlength="450"
                            class="form-control"
                            placeholder="เลขที่ Invoice"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required"
                            >วันที่สินค้าเข้าตัวแทนจำหน่าย:</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              :disabled="isEdit"
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="bciAgentReceivedDate"
                              name="bciAgentReceivedDate"
                              ref="bciAgentReceivedDate"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                            <span class="form-text"></span>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div
                          class="form-group"
                          v-show="
                            this.$parent.abcClaimTypeCode ==
                              'BEER_CLAIM_TYPE_SHOP'
                          "
                        >
                          <label class="label-required"
                            >วันที่สินค้าเข้าร้านค้า:</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              :disabled="isEdit"
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="bciShopReceivedDate"
                              name="bciShopReceivedDate"
                              ref="bciShopReceivedDate"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                            <span class="form-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 class="kt-section__title">รายละเอียด ปัญหาที่พบ:</h3>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label class="label-required">ปัญหาที่พบ:</label>
                          <select2
                            id="bciProblemTypeCode"
                            name="bciProblemTypeCode"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="bciProblemTypeCodeOptions"
                            v-model="bciProblemTypeCode"
                            ref="bciProblemTypeCodeSelect2"
                            @selectChange="onProblemTypeCodeChange"
                            :disabled="IsDisabledProblemTypeCode"
                          ></select2>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>ข้อมูลรูปภาพ:</label>
                          <div class="row">
                            <div class="col-xl-6 col-md-6 col-sm-6">
                              <div class="position-relative">
                                <div class="p-1 d-flex flex-column justify-content-center align-items-center border-dashed">
                                  <input type="file" style="display: none;" ref="fileInput1" accept="image/x-png,image/jpeg" @change="handleFileUpload($event, 0)">
                                  <img v-if="uploadFiles[0]" :src="uploadFiles[0].fileURL" @click="showModal(uploadFiles[0].fileURL)" style="object-fit: contain; width: 100%; height: 100%;">
                                  <button v-if="uploadFiles[0]" type="button" class="btn btn-danger btn-circle btn-icon" 
                                      style="position: absolute; transform: translate(220%, -170%)" 
                                      @click="deleteImage(0)">
                                    <i class="fas fa-trash"></i>
                                  </button>
                                  <button v-else type="button" class="btn btn-primary btn-circle btn-icon" @click="$refs.fileInput1.click()">
                                    <i class="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-6 col-md-6 col-sm-6">
                              <div class="position-relative">
                                <div class="p-1 d-flex flex-column justify-content-center align-items-center border-dashed">
                                  <input type="file" style="display: none;" ref="fileInput1" accept="image/x-png,image/jpeg" @change="handleFileUpload($event, 1)">
                                  <img v-if="uploadFiles[1]" :src="uploadFiles[1].fileURL" @click="showModal(uploadFiles[1].fileURL)" style="object-fit: contain; width: 100%; height: 100%;">
                                  <button v-if="uploadFiles[1]" type="button" class="btn btn-danger btn-circle btn-icon" 
                                      style="position: absolute; transform: translate(220%, -170%)" 
                                      @click="deleteImage(1)">
                                    <i class="fas fa-trash"></i>
                                  </button>
                                  <button v-else type="button" class="btn btn-primary btn-circle btn-icon" @click="$refs.fileInput1.click()">
                                    <i class="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="imageModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                              <div class="modal-content mr-4">
                                <div class="modal-header">
                                  <h5 class="modal-title">รูปภาพ</h5>
                                  <button type="button" class="close" aria-label="Close" @click="closeModal">
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div class="modal-body">
                                  <img :src="modalImageURL" style="max-width: 90%; max-height: 90%; margin: 0 auto; display: block;">
                                  <button type="button" class="close" aria-label="Close" @click="closeModal">
                                    <h6 class="modal-title"><i class="la la-close"></i> ปิดหน้าต่าง</h6>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="form-group">
                          <label class="label-required"
                            >รายละเอียดของปัญหา:</label
                          >
                          <textarea
                            placeholder="รายละเอียดของปัญหา"
                            class="form-control"
                            v-model="bciProblemDesc"
                            id="bciProblemDesc"
                            name="bciProblemDesc"
                            rows="5"
                          ></textarea>
                          <span class="form-text"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                <i class="la la-close"></i> ปิดหน้าต่าง
              </button>
              <button type="submit" class="btn btn-primary">
                <i class="la la-save"></i> บันทึกข้อมูล
              </button>
            </div>
          </div>
        </form>
        <!--end::Form-->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";
import plupload from "plupload";

export default {
  components: {
    select2,
    datepicker,
  },
  data: function() {
    var self = this;
    return {
      IsDisabled: true,
      IsDisabledMachineBarcode: false,
      IsDisabledBarcode: false,
      IsDisabledProblemTypeCode: false,
      IsDisabledDate: true,
      fileUploader: null,
      uploadFiles: [],
      modalImageURL: '',
      isFromImageModal: false,
      checkMacBarcode: true,
      checkBarcode: true,
      isEdit: false,
      bciProductBrandId: null,
      bciProductBrand: null,
      bciMaterialCode: null,
      bciMaterial: null,
      bciBarcode: null,
      bciBarcodeOld: null,
      bciBarcodeNew: null,
      bciDepcode: null,
      bciMacDepcode: null,
      bciManufacturingDate: null,
      bciWeight: 0,
      bciProblemTypeCode: null,
      bciProblemType: null,
      bciProblemDesc: null,
      bciMachineTypeCode: null,
      bciMachineType: null,
      bciMachineBarcode: null,
      bciMachineBarcodeOld: null,
      bciMachineCategory: null,
      bciPressure: null,
      bciTemperature: null,
      bciPMDate: null,
      bciJumpDate: null,
      bciStandardInstallCode: null,
      bciStandardInstall: null,
      bciAgentReceivedDate: null,
      bciShopReceivedDate: null,
      bciInvoice: null,
      //Options
      bciMachineTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "MACHINE_TYPE",
              keySearch: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      bciStandardInstallCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "STANDARD_INSTALL",
              keySearch: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      bciProblemTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "PROBLEM_TYPE",
              keySearch: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      bciMachineCategoryOptions: {
        placeholder: "กรุณาเลือกประเภทเครื่องเบียร์สด",
        allowClear: true,
        data: [
          { id: "false", text: "ไม่มีหัวจ่ายในตัว", data: null },
          { id: "true", text: "มีหัวจ่ายในตัว", data: null },
        ],
      },
      //เฉพาะ หมวดหมู่ สินค้าสำเร็จรูป + ประเภท น้ำเบียร์
      bciMaterialCodeOptions: {
        placeholder: "เลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              productGroupId: "14",
              productTypeId: "22",
              onlyHasBarcode: true,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    showModal(imageURL) {
      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', () => {
        $('body').addClass('modal-open');
      });
    },
    closeModal() {
      $('#imageModal').modal('hide');
    },
    formSubmit: function(e) {
      e.preventDefault();
      if (!$("#addClaimItemModal form").validate().form() || !this.checkMacBarcode || !this.checkBarcode) {
        if(!this.checkMacBarcode){
          this.onBlurBarcode(true);
        }
        if(!this.checkBarcode){
          this.onBlurBarcode(false);
        }
        return false;
      }

      let self = this;
      let router = this.$router;
      let index = this.$route.params.id;
      if (index.includes("add_")) {
        self.$parent.abcClaimItems.push({
          productBrandId: self.bciProductBrandId,
          productBrand: self.bciProductBrand,
          materialCode: self.bciMaterialCode,
          material: self.bciMaterial,
          barcode: self.bciBarcode,
          barcodeNew: self.bciBarcodeNew,
          barcodeOld: self.bciBarcodeOld,
          depCode: self.bciDepcode,
          manufacturingDate: self.bciManufacturingDate,
          weight: self.bciWeight,
          problemTypeCode: self.bciProblemTypeCode,
          problemType: self.bciProblemType,
          problemDesc: self.bciProblemDesc,
          machineTypeCode: self.bciMachineTypeCode,
          machineType: self.bciMachineType,
          machineBarcode: self.bciMachineBarcode,
          machineBarcodeOld: self.bciMachineBarcodeOld,
          macDepcode: self.bciMacDepcode,
          machineCategory: self.bciMachineCategory,
          pressure: self.bciPressure,
          temperature: self.bciTemperature,
          pmDate: self.bciPMDate,
          jumpDate: self.bciJumpDate,
          standardInstallCode: self.bciStandardInstallCode,
          standardInstall: self.bciStandardInstall,
          agentReceivedDate: self.bciAgentReceivedDate,
          shopReceivedDate: self.bciShopReceivedDate,
          invoice: self.bciInvoice,
          uploadFiles: self.uploadFiles,
        });
        self.$parent.index += 1;
      }
      else {
        self.$parent.abcClaimItems[index].productBrandId = self.bciProductBrandId;
        self.$parent.abcClaimItems[index].productBrand = self.bciProductBrand;
        self.$parent.abcClaimItems[index].materialCode = self.bciMaterialCode;
        self.$parent.abcClaimItems[index].material = self.bciMaterial;
        self.$parent.abcClaimItems[index].barcode = self.bciBarcode;
        self.$parent.abcClaimItems[index].barcodeNew = self.bciBarcodeNew;
        self.$parent.abcClaimItems[index].barcodeOld = self.bciBarcodeOld;
        self.$parent.abcClaimItems[index].manufacturingDate = self.bciManufacturingDate;
        self.$parent.abcClaimItems[index].weight = self.bciWeight;
        self.$parent.abcClaimItems[index].problemTypeCode = self.bciProblemTypeCode;
        self.$parent.abcClaimItems[index].problemType = self.bciProblemType;
        self.$parent.abcClaimItems[index].problemDesc = self.bciProblemDesc;
        self.$parent.abcClaimItems[index].machineTypeCode = self.bciMachineTypeCode;
        self.$parent.abcClaimItems[index].machineType = self.bciMachineType;
        self.$parent.abcClaimItems[index].machineBarcode = self.bciMachineBarcode;
        self.$parent.abcClaimItems[index].machineBarcodeOld = self.bciMachineBarcodeOld;
        self.$parent.abcClaimItems[index].machineCategory = self.bciMachineCategory;
        self.$parent.abcClaimItems[index].pressure = self.bciPressure;
        self.$parent.abcClaimItems[index].temperature = self.bciTemperature;
        self.$parent.abcClaimItems[index].pmDate = self.bciPMDate;
        self.$parent.abcClaimItems[index].jumpDate = self.bciJumpDate;
        self.$parent.abcClaimItems[index].standardInstallCode = self.bciStandardInstallCode;
        self.$parent.abcClaimItems[index].standardInstall = self.bciStandardInstall;
        self.$parent.abcClaimItems[index].agentReceivedDate = self.bciAgentReceivedDate;
        self.$parent.abcClaimItems[index].shopReceivedDate = self.bciShopReceivedDate;
        self.$parent.abcClaimItems[index].invoice = self.bciInvoice;
        self.$parent.abcClaimItems[index].uploadFiles = self.uploadFiles;
        //let claim = self.$parent.abcClaimItems[index];
      }
      $("#addClaimItemModal").modal("hide");
    },
    onMaterialCodeChange: function(id, text, data, ref) {
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.bciMaterial = data[0].text;
      }
      //set brand
      if (data[0] && data[0].data) {
        self.bciProductBrandId = data[0].data.productBrandId;
        self.bciProductBrand = data[0].data.productBrandName;
      }
    },
    onProblemTypeCodeChange: function(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciProblemType = data[0].text;
    },
    onMachineTypeCodeChange: function(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciMachineType = data[0].text;
    },
    onStandardInstallCodeChange: function(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciStandardInstall = data[0].text;
    },
    onBlurBarcode(isMachine) {
      let self = this;
      let barcode = isMachine ? self.bciMachineBarcode : self.bciBarcode;
      barcode = barcode ? barcode.split('(')[0].trim() : barcode;
      if (barcode === '') {
        $("#addClaimItemModal form").validate().element(`#${isMachine ? 'bciMachineBarcode' : 'bciBarcode'}`);
      }
      if (barcode != null && barcode != '') {
        axios
          .post("/Api/BeerClaim/BarcodeData", {
            BarcodeNO: barcode,
            IsMachine: isMachine,
          })
          .then(function(response) {
            if (response.status == 200) {
              if (isMachine) {
                self.bciMacDepcode = response.data.departmentMaterialCode ? response.data.departmentMaterialCode : null;
                self.bciMachineBarcode = response.data.departmentMaterialCode ? `${response.data.barcodeNOOld}(${response.data.departmentMaterialCode})` : response.data.barcodeNOOld;
                self.bciMachineBarcodeOld = response.data.barcodeNOOld;
                self.checkMacBarcode = true;
                self.$refs.bciMachineCategorySelect2.setSelectedData({
                  id: response.data.machineCategory,
                });
                if (response.data.pmDateFormat) {
                  self.bciPMDate = moment(
                    response.data.pmDateFormat,
                    "DD/MM/YYYY"
                  );
                  $(self.$refs.bciPMDate).datepicker(
                    "update",
                    response.data.pmDateFormat2
                  );
                }
              } else {
                self.bciDepcode = response.data.departmentMaterialCode ? response.data.departmentMaterialCode : null;
                self.bciBarcode = response.data.departmentMaterialCode ? `${response.data.barcodeNOOld} (${response.data.departmentMaterialCode})` : response.data.barcodeNOOld;
                self.checkBarcode = true;
                if (response.data.barcodeNO) {
                  self.bciBarcodeNew = response.data.barcodeNO;
                }

                if (response.data.barcodeNOOld) {
                  self.bciBarcodeOld = response.data.barcodeNOOld;
                }

                if (response.data.manufacturingDateFormat) {
                  self.bciManufacturingDate = moment(
                    response.data.manufacturingDateFormat,
                    "DD/MM/YYYY"
                  );
                  $(self.$refs.bciManufacturingDate).datepicker(
                    "update",
                    response.data.manufacturingDateFormat2
                  );
                }
              }
            } else {
              if (isMachine) {
                self.checkMacBarcode = false;
                let validator = $("#addClaimItemModal form").validate();
                validator.showErrors({
                  bciMachineBarcode: "ไม่พบข้อมูล BARCODE (เครื่องเบียร์สด)",
                });
                self.$refs.bciMachineCategorySelect2.setSelectedData({
                  id: null,
                });
                self.bciPMDate = null;
                $(self.$refs.bciPMDate).datepicker("update", null);
              } else {
                self.checkBarcode = false;
                let validator = $("#addClaimItemModal form").validate();
                validator.showErrors({
                  bciBarcode: "ไม่พบข้อมูล BARCODE (ถัง)",
                });
                self.bciManufacturingDate = null;
                $(self.$refs.bciManufacturingDate).datepicker("update", null);
              }
            }
          });

        if (!isMachine) {
          axios
            .post("/Api/BeerClaim/BarcodeRetrieveDate", {
              BarcodeNO: barcode,
              AgentCode: self.$parent.abcAgentCodeTmp,
              ShopCode: self.$parent.abcShopCode,
            })
            .then(function(response) {
              if (response.status == 200) {
                if (response.data.agentReceivedDateFormat) {
                  self.bciAgentReceivedDate = moment(
                    response.data.agentReceivedDateFormat,
                    "DD/MM/YYYY"
                  );
                  $(self.$refs.bciAgentReceivedDate).datepicker(
                    "update",
                    response.data.agentReceivedDateFormat2
                  );
                } else {
                  self.bciAgentReceivedDate = null;
                  $(self.$refs.bciAgentReceivedDate).datepicker("update", null);
                }

                if (response.data.shopReceivedDateFormat) {
                  self.bciShopReceivedDate = moment(
                    response.data.shopReceivedDateFormat,
                    "DD/MM/YYYY"
                  );
                  $(self.$refs.bciShopReceivedDate).datepicker(
                    "update",
                    response.data.shopReceivedDateFormat2
                  );
                } else {
                  self.bciShopReceivedDate = null;
                  $(self.$refs.bciShopReceivedDate).datepicker("update", null);
                }
              } else {
                self.bciAgentReceivedDate = null;
                $(self.$refs.bciAgentReceivedDate).datepicker("update", null);

                self.bciShopReceivedDate = null;
                $(self.$refs.bciShopReceivedDate).datepicker("update", null);
              }
            });
        }
      }
    },
    deleteImage(index) {
      this.uploadFiles.splice(index, 1);
      this.$refs.fileInput1.value = '';
    },
    async handleFileUpload(event, index) {
      var self = this;
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const imagePreview = e.target.result;
          self.uploadFiles.push({
            fileURL: imagePreview,
            fileDataContext: file,
          });
        };
        reader.readAsDataURL(file);
      }
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();
    var arrows;

    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.bciManufacturingDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.bciManufacturingDate)
      .datepicker(
        "update",
        !!self.bciManufacturingDate
          ? self.bciManufacturingDate.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.bciManufacturingDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.bciPMDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.bciPMDate)
      .datepicker(
        "update",
        !!self.bciPMDate ? self.bciPMDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.bciPMDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.bciJumpDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.bciJumpDate)
      .datepicker(
        "update",
        !!self.bciJumpDate ? self.bciJumpDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.bciJumpDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.bciAgentReceivedDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.bciAgentReceivedDate)
      .datepicker(
        "update",
        !!self.bciAgentReceivedDate
          ? self.bciAgentReceivedDate.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.bciAgentReceivedDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.bciShopReceivedDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.bciShopReceivedDate)
      .datepicker(
        "update",
        !!self.bciShopReceivedDate
          ? self.bciShopReceivedDate.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.bciShopReceivedDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    //#region :: set validation rules
    $("#addClaimItemModal form").validate({
      rules: {
        bciMachineTypeCode: "required",
        bciMachineBarcode: "required",
        bciMachineCategory: "required",
        bciStandardInstallCode: "required",
        bciMaterialCode: "required",
        bciBarcode: "required",
        bciProblemTypeCode: "required",
        bciProblemDesc: "required",
        bciInvoice: "required",
        bciAgentReceivedDate: "required",
        bciShopReceivedDate: "required",
      },
      messages: {
        bciMachineTypeCode: "กรุณาเลือกชนิดเครื่อง",
        bciMachineBarcode: "กรุณากรอก BARCODE (เครื่องเบียร์สด)",
        bciMachineCategory: "กรุณาเลือกประเภทเครื่องเบียร์สด",
        bciStandardInstallCode: "กรุณาเลือกมาตรฐานติดตั้ง",
        bciMaterialCode: "กรุณาเลือกสินค้า",
        bciBarcode: "กรุณากรอก BARCODE (ถัง)",
        bciProblemTypeCode: "กรุณาเลือกปัญหาที่พบ",
        bciProblemDesc: "กรุณากรอกรายละเอียดของปัญหา",
        bciInvoice: "กรุณากรอกเลขที่ Invoice",
        bciAgentReceivedDate: "กรุณาเลือกวันที่สินค้าเข้าตัวแทนจำหน่าย",
        bciShopReceivedDate: "กรุณาวันที่สินค้าเข้าร้านค้า",
      },
    });
    $(this.$refs.formItem).validate().settings.ignore = ":hidden";
    //#endregion :: set validation rules

    //#region :: Set Value
    let index = this.$route.params.id;
    if (!index.includes("add_")) {
      let claim = self.$parent.abcClaimItems[index];
      if (claim) {
        if(claim.isBeerClaimAdmin !== undefined){
          if(claim.isBeerClaimAdmin && claim.claimStatusCode != "CLAIM_STATUS_SUBMIT"){
            this.IsDisabled = false;
            this.IsDisabledMachineBarcode = true;
            this.IsDisabledBarcode = true;
          }
          if(claim.isBeerClaimAdmin){
            this.IsDisabledDate = false;
          }
          if(claim.isBeerClaimAdmin && claim.claimStatusCode !== 'CLAIM_STATUS_SUBMIT' && 
            claim.claimStatusCode !== 'CLAIM_STATUS_QI_INSPECT' && 
            claim.claimStatusCode !== 'CLAIM_STATUS_COMMIT'
          ){
            this.IsDisabledProblemTypeCode = true;
          }
        }
        //#region :: รายละเอียด สินค้าเบียร์สด
        self.bciProductBrand = claim.productBrand;
        self.bciProductBrandId = claim.productBrandId;
        setTimeout(function() {
          if (claim.materialCode) {
            self.$refs.bciMaterialCodeSelect2.setSelectedData({
              id: claim.materialCode,
              text: claim.material,
            });
          }
        }, 100);
        if (claim.manufacturingDate) {
          let manufacturingDate = moment(claim.manufacturingDate);
          self.bciManufacturingDate = manufacturingDate;
          $(self.$refs.bciManufacturingDate).datepicker(
            "update",
            manufacturingDate.format("DD-MM-YYYY")
          );
        }

        if (claim.agentReceivedDate) {
          let agentReceivedDate = moment(claim.agentReceivedDate);
          self.bciAgentReceivedDate = agentReceivedDate;
          $(self.$refs.bciAgentReceivedDate).datepicker(
            "update",
            agentReceivedDate.format("DD-MM-YYYY")
          );
        }

        if (claim.shopReceivedDate) {
          let shopReceivedDate = moment(claim.shopReceivedDate);
          self.bciShopReceivedDate = shopReceivedDate;
          $(self.$refs.bciShopReceivedDate).datepicker(
            "update",
            shopReceivedDate.format("DD-MM-YYYY")
          );
        }
        claim.barcode = claim.barcode ? claim.barcode.split('(')[0].trim() : claim.barcode;
        self.bciBarcode = claim.depCode ? `${claim.barcodeOld} (${claim.depCode})` : claim.barcodeOld;
        self.bciBarcodeNew = claim.barcodeNew;
        self.bciBarcodeOld = claim.barcodeOld;
        self.bciWeight = claim.weight;
        self.bciInvoice = claim.invoice;
        //#endregion :: รายละเอียด สินค้าเบียร์สด

        //#region :: รายละเอียด ปัญหาที่พบ
        if (claim.problemTypeCode) {
          self.$refs.bciProblemTypeCodeSelect2.setSelectedData({
            id: claim.problemTypeCode,
            text: claim.problemType,
          });
        }
        self.bciProblemDesc = claim.problemDesc;
        //#endregion :: รายละเอียด ปัญหาที่พบ

        //#region :: รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ
        claim.machineBarcode = claim.machineBarcode ? claim.machineBarcode.split('(')[0].trim() : claim.machineBarcode;
        self.bciMachineBarcode = claim.macDepcode ? `${claim.machineBarcodeOld}(${claim.macDepcode})` : claim.machineBarcodeOld;
        self.bciPressure = claim.pressure;
        self.bciTemperature = claim.temperature;

        if (claim.machineTypeCode) {
          self.$refs.bciMachineTypeCodeSelect2.setSelectedData({
            id: claim.machineTypeCode,
            text: claim.machineType,
          });
        }

        if (claim.machineCategory == true || claim.machineCategory === false || claim.machineCategory == 'true' || claim.machineCategory == 'false') {
          self.$refs.bciMachineCategorySelect2.setSelectedData({
            id: claim.machineCategory,
          });
        }

        if (claim.jumpDate) {
          let jumpDate = moment(claim.jumpDate);
          self.bciJumpDate = jumpDate;
          $(self.$refs.bciJumpDate).datepicker(
            "update",
            jumpDate.format("DD-MM-YYYY")
          );
        }

        if (claim.pmDate) {
          let pmDate = moment(claim.pmDate);
          self.bciPMDate = pmDate;
          $(self.$refs.bciPMDate).datepicker(
            "update",
            pmDate.format("DD-MM-YYYY")
          );
        }
        //#endregion :: รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ

        //#region :: รายละเอียด การใช้งาน และการบำรุงรักษา
        if (claim.standardInstallCode) {
          self.$refs.bciStandardInstallCodeSelect2.setSelectedData({
            id: claim.standardInstallCode,
            text: claim.standardInstall,
          });
        }
        //#endregion :: รายละเอียด การใช้งาน และการบำรุงรักษา
        if (claim.uploadFiles && typeof claim.uploadFiles !== 'undefined') {
          self.uploadFiles = claim.uploadFiles;
        }else{
          if (claim.claimItemPicture && typeof claim.claimItemPicture !== 'undefined' && claim.claimItemPicture.length > 0) {
            async function loadPictures() {
              claim.claimItemPicture.map(async (element) => {
                self.uploadFiles.push({
                  claimItemPictureId: element.claimItemPictureId,
                  fileInfoId: element.fileInfoId,
                  fileURL: element.fileData
                });
              });
            }
            loadPictures();
          }
        }

        $("#addClaimItemModal").on("hidden.bs.modal", function() {
          if (!self.isFromImageModal) {
            // Set go back
            router.go(-1);
          }else{
            self.isFromImageModal = false;
          }
        }).modal("show");
      }
      else {
        $("#addClaimItemModal").modal("hide");
      }
    }
    else {
      $("#addClaimItemModal").on("hidden.bs.modal", function() {
        if (!self.isFromImageModal) {
          // Set go back
          router.go(-1);
        }else{
          self.isFromImageModal = false;
        }
      }).modal("show");
    }
    //#endregion :: Set Value
  },
};
</script>

<style lang="scss" scoped>
.btn.btn-icon {
  height: 1.8rem;
  width: 1.8rem;
}
.btn [class*=" fa-"] {
  font-size: 0.8rem;
}
.border-dashed {
  border: 1px dashed;
  height: 140px;
}
</style>



// WEBPACK FOOTER //
// App/Components/BeerClaim/AddBeerClaimItem.vue